import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import ChannelGrid from './components/ChannelGrid';
import FeaturedContent from './components/FeaturedContent';
import LatestContent from './components/LatestContent';
import FAQSection from './components/FAQSection';

export default function Home() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '麻花影视',
    url: 'https://mahua.example.com',
    description: '麻花影视汇集四虎影视、影视飓风、番茄影视、大叔影视等特色频道，提供高清流畅的在线观影体验。',
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '麻花影视',
    url: 'https://mahua.example.com',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://mahua.example.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const webpageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '麻花影视 - 特色影视频道在线观看',
    description: '麻花影视特色频道汇集四虎影视、影视飓风、番茄影视、大叔影视等个性化影视内容，满足特定类型影视观看需求，在线体验高清不缓冲。',
    url: 'https://mahua.example.com',
  };

  return (
    <>
      <SEOHead
        title="首页"
        description="麻花影视特色频道汇集四虎影视、影视飓风、番茄影视、大叔影视等个性化影视内容，满足特定类型影视观看需求，在线体验高清不缓冲。"
        keywords="麻花影视,四虎影视,影视飓风,番茄影视,大叔影视,桃花影视,大象影视,草民影视,麻豆影视在线观看,特色影视频道"
        ogImage="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collection%20collage%20with%20warm%20golden%20and%20red%20tones%2C%20film%20posters%20style%2C%20dramatic%20lighting%2C%20artistic%20composition&width=1200&height=630&seq=og-home&orientation=landscape"
        schema={[orgSchema, websiteSchema, webpageSchema]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <ChannelGrid />
        <FeaturedContent />
        <LatestContent />
        <FAQSection />
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}